import { render, staticRenderFns } from "./LedgerParent.vue?vue&type=template&id=0000ad10&"
import script from "./LedgerParent.vue?vue&type=script&lang=js&"
export * from "./LedgerParent.vue?vue&type=script&lang=js&"
import style0 from "./LedgerParent.vue?vue&type=style&index=0&id=0000ad10&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports